import Page from "../../../../interfaces/Page";
import FirebaseService from "../../../../services/firebase/FirebaseService";
import Book from "../../../../interfaces/Book";
import LogService from "../../../../services/LogService";
import { setAssignmentState, setError, setPage, setRecordedPages } from "./BookScreenState";
import UploadService from "../../../../services/upload/UploadService";

class BookScreenService {
  recordedPageWatch?: () => void = undefined;
  loaded = false;

  async loadPages(bookId: string): Promise<Page[]> {
    let pages: Page[] | undefined = undefined;
    try {
      pages = await FirebaseService.getPages(bookId);
      pages = pages.sort((page1, page2) => page1.navigation.pageNum - page2.navigation.pageNum);
    } catch (err) {
      LogService.exception(err, `BookScreenService.loadPages`, "error in accessing pages of book");
    }

    return pages as Page[];
  }

  async loadBook(bookId: string): Promise<Book | null> {
    try {
      return await FirebaseService.getBook(bookId);
    } catch (err) {
      LogService.exception(err, `BookScreenService.loadBook`, "error occurred in getting book");
    }
    return null;
  }

  roundWpm(wpm: number) {
    return Math.round(wpm);
  }

  // Load all of the details about this assignment (book, submissions, etc...)
  watchAssignment(userId: string, assignmentId: string) {
    if (assignmentId) {
      this.loaded = false;

      FirebaseService.getAssignment(assignmentId).then(async assignment => {
        if (!assignment) {
          setError("Failed to load assignment.");
          this.loaded = true;
          return;
        }

        const book = await this.loadBook(assignment.bookId);
        if (!book) {
          setError("Failed to load book.");
          this.loaded = true;
          return;
        }

        if (book.coverImage) {
          book.coverImageUrl = await UploadService.getCoverImagePath(book.coverImage);
        }

        const pages = await this.loadPages(book.id);

        if (pages) {
          setAssignmentState({
            assignment: assignment,
            book: book,
            bookTitle: book.name,
            pages: pages,
            recordedPages: [],
          });

          setPage(0);
          this.loaded = true;

          this.recordedPageWatch = FirebaseService.watchStudentRecordedPages(
            userId,
            assignment.bookId,
            async recordedPages => {
              setRecordedPages(recordedPages);
            },
          );
        } else {
          LogService.exception(
            "No pages found",
            `BookScreenService.watchAssignment`,
            `No pages found for book: ${assignment.bookId}`,
          );

          setError("Failed to load assignment pages.");
          this.loaded = true;
        }
      });
    }
  }

  cleanup() {
    if (this.recordedPageWatch) {
      this.recordedPageWatch();
      this.recordedPageWatch = undefined;
    }
  }
}

export default BookScreenService;
